import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.50027 6.75V6C7.50027 4.80653 7.97438 3.66193 8.81829 2.81802C9.66221 1.97411 10.8068 1.5 12.0003 1.5C13.1937 1.5 14.3383 1.97411 15.1823 2.81802C16.0262 3.66193 16.5003 4.80653 16.5003 6V6.75H18.4873C18.9507 6.74993 19.3977 6.92146 19.7421 7.23151C20.0865 7.54155 20.3038 7.96815 20.3523 8.429L21.6153 20.429C21.6427 20.6903 21.615 20.9545 21.5338 21.2045C21.4525 21.4544 21.3197 21.6844 21.1439 21.8797C20.968 22.075 20.7531 22.2311 20.513 22.338C20.2729 22.4448 20.0131 22.5 19.7503 22.5H4.25027C3.98749 22.5 3.72763 22.4448 3.48755 22.338C3.24748 22.2311 3.03254 22.075 2.85669 21.8797C2.68084 21.6844 2.548 21.4544 2.46679 21.2045C2.38558 20.9545 2.3578 20.6903 2.38527 20.429L3.64827 8.429C3.74927 7.474 4.55327 6.75 5.51327 6.75H7.50027ZM9.87895 3.87868C10.4416 3.31607 11.2046 3 12.0003 3C12.7959 3 13.559 3.31607 14.1216 3.87868C14.6842 4.44129 15.0003 5.20435 15.0003 6V6.75H9.00027V6C9.00027 5.20435 9.31634 4.44129 9.87895 3.87868ZM14.9279 13.8317C15.1687 13.4946 15.0906 13.0262 14.7536 12.7855C14.4165 12.5447 13.9481 12.6228 13.7073 12.9598L11.3252 16.2948L10.2132 15.1828C9.9203 14.8899 9.44542 14.8899 9.15253 15.1828C8.85964 15.4757 8.85964 15.9506 9.15253 16.2435L10.8906 17.9815C11.0465 18.1374 11.263 18.2168 11.4828 18.1986C11.7025 18.1804 11.9031 18.0665 12.0312 17.8871L14.9279 13.8317Z"
        fill={colorValue}
      />
    </svg>
  );
};
